import { Controller } from "@hotwired/stimulus"

const pendingUpdates = new WeakMap()

// Keep the latest streams on the drawer until it closes. Its frame can visit
// other pages after saving, disconnecting this controller in the meantime.
export default class extends Controller {
  connect() {
    const drawer = this.element.closest(".bottom-drawer")
    if (!drawer) return

    const streams = this.element.content.cloneNode(true)
    const pending = pendingUpdates.get(drawer)
    if (pending) {
      pending.streams = streams
      return
    }

    const update = { streams }
    pendingUpdates.set(drawer, update)
    drawer.addEventListener("close", () => {
      pendingUpdates.delete(drawer)
      document.body.append(update.streams)
    }, { once: true })
  }
}
